import React from 'react'
import { Route, Switch } from 'react-router'
import { GetMessageAppearance } from './pages/GetMessageAppearance'

export const MessageAppearanceRouterV2 = () => (
  <Switch>
    <Route exact path={`/message-appearance/:id`} component={GetMessageAppearance} />
  </Switch>
)
